import React from 'react';
import classNames from 'classnames';
import './new-badge.scss';

const BETA_TOOLTIP: string =
  'Beta — available for key pickups and walkthroughs today. Still expanding, so some flows (like service requests) aren’t supported yet.';

interface NewBadgeProps {
  label?: string;
  className?: string;
  spaced?: boolean;
  spacedRight?: boolean;
  spacedTop?: boolean;
  spacedBottom?: boolean;
  beta?: boolean;
}

const NewBadge = ({
  label,
  className,
  spaced,
  spacedRight,
  spacedTop,
  spacedBottom,
  beta = false,
}: NewBadgeProps) => {
  const resolvedLabel: string = label ?? (beta ? 'Beta' : 'NEW');

  return (
    <span
      title={beta ? BETA_TOOLTIP : undefined}
      className={classNames(
        'new-badge',
        {
          'new-badge-beta': beta,
          'new-badge-spaced': spaced,
          'new-badge-spaced-right': spacedRight,
          'new-badge-spaced-top': spacedTop,
          'new-badge-spaced-bottom': spacedBottom,
        },
        className
      )}
    >
      {beta && <span className="new-badge-dot" aria-hidden="true" />}
      {resolvedLabel}
    </span>
  );
};

export default NewBadge;